import { render, staticRenderFns } from "./PersonalGoalTable.vue?vue&type=template&id=552e3b85&scoped=true"
import script from "./PersonalGoalTable.vue?vue&type=script&lang=js"
export * from "./PersonalGoalTable.vue?vue&type=script&lang=js"
import style0 from "./PersonalGoalTable.vue?vue&type=style&index=0&id=552e3b85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552e3b85",
  null
  
)

export default component.exports